module.exports = __webpack_public_path__ + "img/ufaslot.27628c95.png";